import { createSlice } from '@reduxjs/toolkit';

const recoverAccountDataSlice = createSlice({
  name: 'recoverAccount',
  initialState: {
    alias: [],
    sendCode: false,
    checkToken: false
  },
  reducers: {
    alias(state, action) {
      const censorEmail = email => {
        const arr = email.split('@');
        return arr[0] + '@' + censorWord(arr[1]);
      };

      const censorWord = str => {
        return str[0] + '*'.repeat(str.length - 2);
      };

      const hidePhone = (text, limit) => {
        const ellipsis = '******';
        if (text.length > limit) {
          text = text.substring(0, limit) + ellipsis;
        }
        return text;
      };
      const editData = action.payload.alias;
      if (editData !== 'noUser') {
        editData.map(item => {
          if (item.email === 1) {
            item.newValueMask = censorEmail(item.alias);
          } else {
            item.newValueMask = hidePhone(item.alias, 5);
          }
        });
      }
      state.alias = [editData, new Date()];
    },
    code(state, action) {
      state.sendCode = action.payload.code;
    },
    token(state, action) {
      state.checkToken = [action.payload.tokenInfo, new Date()];
    }
  }
});

export const recoverAccountDataActions =
  recoverAccountDataSlice.actions;

export default recoverAccountDataSlice;
